import { useEffect, React } from "react";
import MisionAndVision from "./MisioAndVision";

export default function Nosotros() {
  useEffect(() => {
    document.title = "Taxi Cusco | AMARU DRIVER - Transporte y Turismo";
  }, []);

  return (
    <>
      <header className="relative">
        <img
          className="pagadiario-container"
          src={`${process.env.PUBLIC_URL}/images/nosotros.png`}
          alt="Agencia de viajes y taxi en Cusco - AMARU DRIVER"
        />
        <div className="absolute w-full h-full top-0">
          <div className="w-full h-full mx-auto max-w-7xl grid lg:content-center items-end px-4 lg:px-16">
            <h1 className="my-auto text-[24px] md:text-[32px] lg:text-[64px] font-bold text-primary-50">
              Nosotros | Taxi Cusco y Transporte VIP
            </h1>
          </div>
        </div>
      </header>

      <main className="w-full">
        <div className="w-full max-w-7xl mx-auto px-10 my-2 lg:my-16">
          {/* HISTORIA */}
          <section id="historia">
            <h2 className="font-bold text-center text-[20px] lg:text-[48px] text-primary-800 mb-2 lg:mb-8">
              Nuestra Historia en el Transporte y Taxi Cusco
            </h2>

            <article className="flex flex-col md:flex-row justify-center">
              <div className="w-full md:w-6/12 py-2">
                <p className="text-primary-800 font-light text-justify text-[14px] lg:text-[16px]">
                  Nuestra agencia de viajes y <strong>servicio de taxi en Cusco</strong> nació hace más de
                  5 años con la misión de brindar experiencias turísticas auténticas, seguras y
                  personalizadas en el corazón del Perú. Desde nuestros inicios, nos hemos
                  comprometido con un turismo responsable y sostenible, fomentando el respeto por la
                  cultura local, la preservación del medio ambiente y el fortalecimiento de las
                  comunidades andinas.
                </p>
                <br />
                <p className="text-primary-800 font-light text-justify text-[14px] lg:text-[16px]">
                  A lo largo de este tiempo, hemos diseñado una amplia variedad de tours, traslados y
                  experiencias únicas que permiten a nuestros visitantes descubrir la magia de Cusco.
                  Cada recorrido y servicio de <strong>transporte privado</strong> está cuidadosamente
                  planificado por un equipo profesional apasionado por el turismo y la excelencia.
                </p>
                <br />
                <h3 className="text-primary-800 font-bold text-[18px] mb-2">
                  Transporte VIP y Experiencias Personalizadas
                </h3>
                <p className="text-primary-800 font-light text-justify text-[14px] lg:text-[16px]">
                  Ofrecemos un <strong>servicio de taxi VIP en Cusco</strong> para quienes buscan viajar
                  con comodidad, privacidad y estilo. Nuestro servicio está diseñado para turistas,
                  familias o grupos reducidos que desean una experiencia exclusiva durante su estancia
                  en Cusco. Contamos con vehículos modernos y conductores profesionales.
                </p>
              </div>
              <div className="flex-1 flex items-center ml-8 justify-center">
                <img
                  className="w-full shadow-2xl rounded-lg"
                  src={`${process.env.PUBLIC_URL}/images/principios_donald.jpg`}
                  alt="Servicio de transporte y taxi en Cusco"
                />
              </div>
            </article>
          </section>

          {/* MISION Y VISION */}
          <section id="mision-vision" className="my-16">
            <MisionAndVision />
          </section>

          {/* PROPÓSITO */}
          <section id="proposito" className="mb-4">
            <h2 className="font-bold text-center text-[20px] md:text-[48px] text-primary-800 mb-8">
              Nuestro Propósito en Taxi Cusco
            </h2>
            <div className="flex flex-col lg:flex-row">
              <div className="flex-1 flex items-center justify-center">
                <img
                  className="w-full shadow-2xl rounded-lg"
                  src={`${process.env.PUBLIC_URL}/images/proposito_donald.jpg`}
                  alt="Propósito de AMARU DRIVER Taxi Cusco"
                />
              </div>
              <div className="w-full lg:w-6/12 p-4">
                <p className="text-primary-800 font-light text-justify text-[14px] lg:text-[16px]">
                  Nuestro propósito es proporcionar experiencias turísticas excepcionales y
                  significativas, ofreciendo servicios de <strong>taxi en Cusco</strong> confiables,
                  seguros y personalizados. Queremos que cada viaje sea una experiencia inolvidable.
                </p>
                <br />
                <ul className="text-primary-800 font-light list-disc ml-8 text-[14px] lg:text-[16px]">
                  <li>Autenticidad cultural y servicio local.</li>
                  <li>Sostenibilidad ambiental y social.</li>
                  <li>Innovación en transporte turístico.</li>
                  <li>Calidad y compromiso con el cliente.</li>
                  <li>Educación y conciencia turística.</li>
                  <li>Experiencias memorables en cada traslado.</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}